import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EventPayloadDetails } from 'graphql/libs/automata-sync/types';
import { UserEventType } from 'graphql/libs/events-reader/src/graphql';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';

@Component({
    selector: 'app-public-session-deactivated',
    templateUrl: './public-session-deactivated.component.html',
    styleUrls: ['./public-session-deactivated.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PublicSessionDeactivatedComponent implements OnInit {
  @Input()
  @ParseJson
  details: EventPayloadDetails[UserEventType.PublicSessionDeactivated];

  constructor() {}

  ngOnInit(): void {}
}
